<template>
	<el-cascader
		v-bind="$listeners"
		:class="size"
		:props="casProps"
		:size="size"
		:options="options"
		:collapse-tags="collapseTags"
		v-model="depts"
		@change="change"
		placeholder="全部"
		@visible-change="
			val => {
				$emit('visibleChange', val);
			}
		"
	>
		<template slot-scope="{ data }">
			<span>{{ data.name }}</span>
		</template>
	</el-cascader>
</template>
<script>
import { managerDept } from '@/api/common';
import { getDepName } from '@/api/teamManage';
export default {
	props: {
		value: [Array, String, Object],
		// echo: [String, Number, Array],
		size: {
			type: String,
			default: 'mini',
		},
		collapseTags: {
			type: Boolean,
			default: false,
		},
		returnArray: {
			type: Boolean,
			default: false,
		},
		multiple: {
			type: Boolean,
			default: true,
		},
		is_belong: {
			type: Boolean,
			default: false,
		},
		scene: {
			type: String,
			default: '',
		},
	},
	watch: {
		multiple: {
			handler(to) {
				this.casProps.multiple = to;
			},
			immediate: true,
		},
		value: {
			handler(val = []) {
				this.depts = val ? val?.map(item => this.findTargetDeptId(item)) : [];
			},
			deep: true,
			immediate: true,
		},
		deptList: {
			handler() {
				this.depts = this.value ? this.value?.map(item => this.findTargetDeptId(item)) || [] : [];
			},
		},
	},
	data() {
		return {
			depts: [],
			options: [],
			deptList: [],
			casProps: {
				multiple: true,
				checkStrictly: true,
				value: 'id',
				label: 'name',
			},
			deptsMap: new Map(),
		};
	},
	created() {
		this.managerDept();
	},
	methods: {
		async managerDept() {
			const { is_belong } = this;
			// 团队公海 使用无数据视角限制的接口
			const api = this.scene == 'groupSeas' ? getDepName : managerDept;
			let res = await api({});
			if (this.scene == 'groupSeas') {
				res = {
					code: 0,
					data: res,
				};
			}
			const { code, data } = res;
			if (code !== 0) return;
			if (Array.isArray(data)) {
				this.deptList = data;
				// 初始化部门map对象
				this.deptList.forEach(item => this.deptsMap.set(item.id, item.parentId));
				if (data.length === 1) return (this.options = data);
				// 获取首个节点信息
				const ids = data.map(item => item.id);
				const rootId = data.find(item => !ids.includes(item.parentId))?.parentId;
				let obj1 = { parentId: '0', name: '无归属', id: '-1' };
				let arr = [];
				arr = is_belong ? [...data, obj1] : data;
				this.options = this.arrayToTree(arr, rootId);
			}
		},
		//转换一维数组成树形数组
		arrayToTree(data, pid = 0) {
			return data
				.filter(item => item.parentId === pid)
				.map(item => ({ ...item, children: this.arrayToTree(data, item.id).length ? this.arrayToTree(data, item.id) : null }));
		},
		change(val) {
			const { returnArray, multiple } = this;
			if (multiple) {
				// 获取每次选中项的最后一个id
				let arr = val?.map(item => item[item.length - 1]);
				let detNameList = arr.map(item => this.deptList?.find(v => v.id === item).name);
				this.$emit('input', returnArray ? arr : arr.join(','), detNameList);
				this.$emit('change', returnArray ? arr : arr.join(','), val);
			} else {
				let arr = val?.slice(-1);
				this.$emit('input', returnArray ? arr : arr.join(','));
				this.$emit('change', returnArray ? arr : arr.join(','));
			}
		},
		reset() {
			this.depts = [];
		},
		/**
		 * @description: 查找目标部门ID的所有上级部门ID
		 * @param {*} id 目标部门ID
		 * @return {*} 目标目标的所有上级ID数组，包含本部门
		 * @acthor: Li Yong
		 * @Date: 2023-03-01 17:39:31
		 */
		findTargetDeptId(id) {
			let arr = [];
			const _findTargetDeptId = (id, arr) => {
				if (this.deptsMap.has(id)) {
					_findTargetDeptId(this.deptsMap.get(id), arr);
					arr.push(id);
				}
				return;
			};
			_findTargetDeptId(id, arr);
			return arr;
		},
	},
};
</script>
<style lang="less" scoped>
.mini {
	/deep/ .el-input__inner {
		width: 140px;
	}

	/deep/ .el-tag--info {
		max-width: 60px;
	}
}
.small {
	/deep/ .el-tag--info {
		max-width: 110px;
	}
}

.medium {
	/deep/ .el-tag--info {
		max-width: 150px;
	}
}
</style>
